// Paths a player may be sent to after logging in. Anything else (admin pages, paths that no
// longer exist, a stale value left in localStorage) falls back to the dashboard instead of
// dropping the player on a page that is empty or that they have no access to.
const PLAYER_REDIRECT_PREFIXES = ["/player/", "/view-tournaments", "/season-confirm/"];

export const getSafePlayerRedirect = (
  stored: string | null,
  fallback = "/player/dashboard",
): string => {
  if (!stored || !stored.startsWith("/") || stored.startsWith("//")) return fallback;
  // Never send a player back to the login screens
  if (stored.startsWith("/player/login") || stored.startsWith("/login")) return fallback;
  const allowed = PLAYER_REDIRECT_PREFIXES.some(
    (p) => stored === p.replace(/\/$/, "") || stored.startsWith(p),
  );
  return allowed ? stored : fallback;
};
